goog.provide("shadow.js.shim.module$$carbon$icons_react$es$Launch$default");
shadow.js.shim.module$$carbon$icons_react$es$Launch$default = shadow.js.require(365, {}).default;
